import {Component, Input, OnInit} from '@angular/core';
import {UtilsService} from '../../core/utils/utils.service';

@Component({
  selector: 'app-iframe-page',
  templateUrl: './iframe-page.component.html',
  styleUrls: ['./iframe-page.component.scss']
})

export class IframePageComponent implements OnInit {
  @Input() data;
  height: {};
  activeTab: {};
  activeTabIndex = 0;
  usuario;
  titulo;
  params;
  @Input() iframeTipo;
  @Input() classList;

  constructor(private _utils: UtilsService) {
    this.usuario = this._utils.getUsuario();
  }

  getParamsDesktop() {
    this.params = {
      lojaId: this.usuario ? this.usuario.loja : 0,
      tipo: this.iframeTipo ? this.iframeTipo : this.data['linkNome']
    };
    if (this.data['global']) {
      this.params.lojaId = 0;
    }
    return this.params;
  }

  getParamsMobile() {
    return this.params = {
      lojaId: this.usuario ? this.usuario.loja : 0,
      tipo: this.iframeTipo ? this.iframeTipo + '_mobile' : this.data['linkNome'] + '_mobile'
    };
  }

  getHeight() {
    const component = this;
    setTimeout(() => {
      component.height = {height: 'calc(100% - 50px)', minHeight: 'calc(100% - 50px)'};
    }, 6000);
  }

  changeIframeTab(tab, i) {
    this.activeTab = tab;
    this.activeTabIndex = i;
  }

  ngOnInit() {
    if (this.data) {
      if (!this._utils.mobileCheck()) {
        this.getParamsDesktop();
      } else {
        this.getParamsMobile();
      }
    }
  }
}
